import BotonManualHeader from "../../components/BotonManualHeader";
import React, { useState, useEffect } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Table,
  Badge,
  Pagination,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  collection,
  collectionGroup,
  query,
  where,
  orderBy,
  getFirestore,
  doc,
  getDoc,
} from "firebase/firestore";
// getDocs instrumentado: informa cuántas lecturas hace esta pantalla para
// poder atribuir el consumo de Firestore a cada usuario (visible solo para superAdmin).
import { getDocs } from "../../functions/getDocsInstrumentado";
import { establecerOrigenConsumo } from "../../functions/consumoLecturas";
import firebaseApp from "../../firebase/credenciales";
import {
  FaFilter,
  FaFileSignature,
  FaCalendarAlt,
  FaUsers,
  FaEye,
  FaDownload,
  FaSearch,
  FaTimes,
  FaExclamationTriangle,
  FaFileAlt,
  FaSortAmountDown,
  FaSortAmountUp,
  FaUpload,
  FaPen,
  FaChartBar,
  FaRegFileAlt,
  FaCheckCircle,
  FaExclamationCircle,
  FaInfoCircle,
  FaCog,
  FaClock,
} from "react-icons/fa";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import * as XLSX from "xlsx";

const db = getFirestore(firebaseApp);

// Tipos de documento disponibles (lista completa)
const tiposDocumento = [
  { value: "", label: "Todos los documentos" },
  { value: "Aprobación de Empleo", label: "Aprobación de Empleo" },
  { value: "Perfil de cargo", label: "Perfil de cargo" },
  {
    value: "Ficha de Ingreso del trabajador",
    label: "Ficha de Ingreso del trabajador",
  },
  {
    value: "Declaración Jurada de Domicilio",
    label: "Declaración Jurada de Domicilio",
  },
  {
    value: "Declaración Jurada de Quinta Categoría o certificado de 5ta",
    label: "Declaración Jurada de Quinta Categoría",
  },
  {
    value: "Declaración Jurada de apertura para pago de Remuneración",
    label: "Declaración Jurada de apertura para pago",
  },
  {
    value: "Convenio de Confidencialidad",
    label: "Convenio de Confidencialidad",
  },
  {
    value: "Autorización para uso de datos personales",
    label: "Autorización para uso de datos personales",
  },
  {
    value: "Consentimiento Informado (realización de exámenes médicos)",
    label: "Consentimiento Informado",
  },
  {
    value: "Compromiso de Responsabilidad con los bienes",
    label: "Compromiso de Responsabilidad con los bienes",
  },
  {
    value: "Carta de Compromiso (Vigilancia de salud)",
    label: "Carta de Compromiso (Vigilancia de salud)",
  },
  {
    value: "Declaración jurada de beneficiarios - Vida Ley",
    label: "Declaración jurada de beneficiarios",
  },
  {
    value: "Convenio de entrega Digital de Documentos Laborales",
    label: "Convenio de entrega Digital",
  },
  {
    value: "Declaración de Exoneración de responsabilidad",
    label: "Declaración de Exoneración de responsabilidad",
  },
  { value: "DNI del trabajador (copia)", label: "DNI del trabajador (copia)" },
  {
    value: "Certificado de Unión de Hecho o Matrimonio",
    label: "Certificado de Unión de Hecho o Matrimonio",
  },
  {
    value: "DNI Hijos o Partida de Nacimiento de Hijos",
    label: "DNI Hijos o Partida de Nacimiento",
  },
  {
    value: "DNI de esposa/concubina (o)",
    label: "DNI de esposa/concubina (o)",
  },
  {
    value: "Foto tamaño carnet o pasaporte",
    label: "Foto tamaño carnet o pasaporte",
  },
  { value: "Curriculum Vitae", label: "Curriculum Vitae" },
  { value: "Certificados de trabajo", label: "Certificados de trabajo" },
  { value: "Certificado Habilitación", label: "Certificado Habilitación" },
  { value: "Carta de aviso de egresado", label: "Carta de aviso de egresado" },
  {
    value: "Certificado Antecedentes Penales",
    label: "Certificado Antecedentes Penales",
  },
  {
    value: "Certificado de Antecedentes Policiales",
    label: "Certificado de Antecedentes Policiales",
  },
  { value: "Lista de chequeo de HV", label: "Lista de chequeo de HV" },
  {
    value: "Informe final de Reclutamiento",
    label: "Informe final de Reclutamiento",
  },
  {
    value: "Prueba de Conocimiento Específico",
    label: "Prueba de Conocimiento Específico",
  },
  { value: "Prueba de HSEQ", label: "Prueba de HSEQ" },
  { value: "Entrevista Jefe directo", label: "Entrevista Jefe directo" },
  { value: "Informe Disc", label: "Informe Disc" },
  {
    value: "Constancia de aptitud de médica",
    label: "Constancia de aptitud médica",
  },
  { value: "T-Registro", label: "T-Registro" },
  {
    value: "Recibo de Manual de Funciones",
    label: "Recibo de Manual de Funciones",
  },
  {
    value: "Carta de aviso personal de Confianza y Dirección",
    label: "Carta de aviso personal de Confianza",
  },
  { value: "Aviso de tercerización", label: "Aviso de tercerización" },
  { value: "Contratos", label: "Contratos" },
  { value: "Plan de Capacitación", label: "Plan de Capacitación" },
  {
    value: "Boletín Informativo de Sistema de Pensiones",
    label: "Boletín Informativo de Sistema de Pensiones",
  },
  {
    value: "Reglamento Interno de Trabajo",
    label: "Reglamento Interno de Trabajo",
  },
  {
    value: "Reglamento de seguridad y salud en el trabajo",
    label: "Reglamento de seguridad y salud",
  },
  { value: "Hoja de Ruta", label: "Hoja de Ruta" },
  {
    value: "Inducción de Talento Humano",
    label: "Inducción de Talento Humano",
  },
  {
    value: "Inducción de Seguridad (HSEQ)",
    label: "Inducción de Seguridad (HSEQ)",
  },
  { value: "IPER por puesto de trabajo", label: "IPER por puesto de trabajo" },
  {
    value: "Carta Compromiso / Inducción de la vigilancia a la gestación",
    label: "Carta Compromiso - vigilancia gestación",
  },
  {
    value: "Charla y/o Inducción sobre Hostigamiento Sexual",
    label: "Charla Hostigamiento Sexual",
  },
];

// Estados de documento
const estadosDocumento = [
  { value: "", label: "Todos los estados" },
  { value: "firmado", label: "Firmado", color: "success" },
  { value: "pendiente", label: "Pendiente", color: "warning" },
  { value: "visto", label: "Solo Visto", color: "info" },
  { value: "activo", label: "Activo", color: "primary" },
];

// Determinar tipo de documento (firma o carga)
const getDocumentType = (tipoDoc) => {
  const documentosParaFirmar = [
    "Declaración Jurada de Domicilio",
    "Declaración Jurada de Quinta Categoría o certificado de 5ta",
    "Declaración Jurada de apertura para pago de Remuneración",
    "Convenio de Confidencialidad",
    "Autorización para uso de datos personales",
    "Consentimiento Informado (realización de exámenes médicos)",
    "Compromiso de Responsabilidad con los bienes",
    "Carta de Compromiso (Vigilancia de salud)",
    "Declaración jurada de beneficiarios - Vida Ley",
    "Convenio de entrega Digital de Documentos Laborales",
    "Declaración de Exoneración de responsabilidad",
    "Recibo de Manual de Funciones",
    "Carta de aviso personal de Confianza y Dirección",
    "Aviso de tercerización",
    "Contratos",
    "Plan de Capacitación",
    "Boletín Informativo de Sistema de Pensiones",
    "Reglamento Interno de Trabajo",
    "Reglamento de seguridad y salud en el trabajo",
    "Carta Compromiso / Inducción de la vigilancia a la gestación",
  ];

  return documentosParaFirmar.includes(tipoDoc) ? "sign" : "upload";
};

function ListaDocumentosDetalle({ usuario }) {
  const [rucEmpresa] = useState(usuario?.ruc || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Filtros simplificados
  const [filtros, setFiltros] = useState({
    tipoDocumento: "",
    periodo: format(new Date(), "yyyy-MM"), // Mes actual por defecto
  });

  // Datos
  const [documentos, setDocumentos] = useState([]);
  const [documentosFiltrados, setDocumentosFiltrados] = useState([]);

  // Cache de usuarios - OPTIMIZACIÓN
  const [usuariosCache, setUsuariosCache] = useState(new Map());
  const [cacheLoaded, setCacheLoaded] = useState(false);

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);

  // Modal para ver documento
  const [showModal, setShowModal] = useState(false);
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null);

  // Ordenamiento
  const [sortField, setSortField] = useState("fechaDoc");
  const [sortDirection, setSortDirection] = useState("desc");

  // Estadísticas
  const [estadisticas, setEstadisticas] = useState({
    total: 0,
    firmados: 0,
    pendientes: 0,
    vistos: 0,
    porcentajeFirmados: 0,
  });

  // NUEVA FUNCIÓN: Cargar todos los usuarios de la empresa una sola vez
  const cargarUsuariosEmpresa = async () => {
    if (cacheLoaded || !rucEmpresa) return;

    try {
      console.log(`� Cargando cache de usuarios para RUC: ${rucEmpresa}`);

      establecerOrigenConsumo("onboarding:documentos");
      const usersRef = collection(db, "users");
      const qUsers = query(
        usersRef,
        where("rucEmpresa", "==", rucEmpresa),
        where("activo", "==", true)
      );

      const usersSnapshot = await getDocs(qUsers);
      const usuariosMap = new Map();

      usersSnapshot.forEach((doc) => {
        const userData = doc.data();
        const nombreCompleto = `${userData.name || ""} ${
          userData.apellidos || ""
        }`.trim();
        usuariosMap.set(userData.dni, nombreCompleto || "Sin nombre");
      });

      console.log(`✅ Cache cargado: ${usuariosMap.size} usuarios`);
      setUsuariosCache(usuariosMap);
      setCacheLoaded(true);
    } catch (error) {
      console.error("🔥 Error al cargar cache de usuarios:", error);
    }
  };

  // FUNCIÓN OPTIMIZADA: Obtener nombre desde cache
  const obtenerNombreCompleto = (dni) => {
    return usuariosCache.get(dni) || "Usuario no encontrado";
  };

  // Función para obtener datos - OPTIMIZADA
  const fetchDocumentos = async () => {
    if (!rucEmpresa) {
      setError("No se encontró el RUC de la empresa");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      establecerOrigenConsumo("onboarding:documentos");
      // Cargar cache de usuarios primero si no está cargado
      if (!cacheLoaded) {
        await cargarUsuariosEmpresa();
      }

      console.log(
        `🚀 Iniciando búsqueda de documentos para RUC: ${rucEmpresa}`
      );

      // Crear query base
      let q = query(
        collectionGroup(db, "legajo"),
        where("ruc", "==", rucEmpresa),
        where("activo", "==", true)
      );

      // Agregar filtro por tipo de documento si está seleccionado
      if (filtros.tipoDocumento) {
        q = query(q, where("tipo", "==", filtros.tipoDocumento));
        console.log(`🔍 Filtro por tipo: ${filtros.tipoDocumento}`);
      }

      // Agregar ordenamiento
      q = query(q, orderBy("fechaDoc", "desc"));

      const snapshot = await getDocs(q);
      const documentosData = [];
      console.log(`📄 Documentos encontrados: ${snapshot.size}`);

      // Calcular rango de fechas del período seleccionado
      const [year, month] = filtros.periodo.split("-");
      const fechaInicio = new Date(year, month - 1, 1);
      const fechaFin = new Date(year, month, 0, 23, 59, 59);
      console.log(
        `📅 Período seleccionado: ${fechaInicio.toLocaleDateString()} - ${fechaFin.toLocaleDateString()}`
      );

      snapshot.forEach((doc) => {
        const data = doc.data();
        console.log("Tipo en Firestore:", data.tipo);
        // Procesar fechas
        const fechaDoc = data.fechaDoc?.toDate
          ? data.fechaDoc.toDate()
          : new Date(data.fechaDoc);
        const fechaFirma = data.fechaFirma?.toDate
          ? data.fechaFirma.toDate()
          : data.fechaFirma
          ? new Date(data.fechaFirma)
          : null;
        const fechaVista = data.fechaVista?.toDate
          ? data.fechaVista.toDate()
          : data.fechaVista
          ? new Date(data.fechaVista)
          : null;

        // Filtrar por período (mes/año)
        if (fechaDoc >= fechaInicio && fechaDoc <= fechaFin) {
          // Determinar estado
          let estado = "activo";
          if (fechaFirma) {
            estado = "firmado";
          } else if (fechaVista) {
            estado = "visto";
          } else {
            estado = "pendiente";
          }

          // OPTIMIZACIÓN: Obtener nombre del cache en lugar de consulta individual
          const nombreCompleto = obtenerNombreCompleto(data.dni);

          documentosData.push({
            id: doc.id,
            ...data,
            fechaDoc,
            fechaFirma,
            fechaVista,
            estado,
            tipoDocumento: getDocumentType(data.tipo),
            nombreCompleto,
            path: doc.ref.path, // Para referencia
          });
        }
      });

      console.log(`✅ Documentos procesados: ${documentosData.length}`);
      setDocumentos(documentosData);
      calcularEstadisticas(documentosData);
    } catch (err) {
      console.error("🔥 Error al cargar documentos:", err);
      setError("Error al cargar los documentos. Inténtalo nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  // Cargar cache de usuarios al montar el componente
  useEffect(() => {
    if (rucEmpresa && !cacheLoaded) {
      cargarUsuariosEmpresa();
    }
  }, [rucEmpresa]);

  // Calcular estadísticas
  const calcularEstadisticas = (docs) => {
    const total = docs.length;
    const firmados = docs.filter((doc) => doc.estado === "firmado").length;
    const pendientes = docs.filter((doc) => doc.estado === "pendiente").length;
    const vistos = docs.filter((doc) => doc.estado === "visto").length;
    const porcentajeFirmados =
      total > 0 ? ((firmados / total) * 100).toFixed(1) : 0;
    // NUEVO: Calcular documentos activos (sin procesar)
    const activos = docs.filter((doc) => doc.estado === "activo").length;

    setEstadisticas({
      total,
      firmados,
      pendientes,
      vistos,
      activos, // NUEVO
      porcentajeFirmados,
    });
  };

  // Filtrar documentos (ahora solo ordena, ya no hay filtros adicionales)
  useEffect(() => {
    let filtered = [...documentos];

    // Ordenamiento
    filtered.sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];

      // Manejar fechas
      if (sortField.includes("fecha")) {
        aVal = aVal ? new Date(aVal) : new Date(0);
        bVal = bVal ? new Date(bVal) : new Date(0);
      }

      if (sortDirection === "asc") {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

    setDocumentosFiltrados(filtered);
    setCurrentPage(1);
  }, [documentos, sortField, sortDirection]);

  // Manejar cambios en filtros
  const handleFiltroChange = (campo, valor) => {
    setFiltros((prev) => ({ ...prev, [campo]: valor }));
  };

  // Limpiar filtros - ACTUALIZADO para recargar cache si es necesario
  const limpiarFiltros = () => {
    setFiltros({
      tipoDocumento: "",
      periodo: format(new Date(), "yyyy-MM"),
    });
    // Si el cache no está cargado, cargarlo
    if (!cacheLoaded) {
      cargarUsuariosEmpresa();
    }
  };

  // Exportar a Excel
  const exportarExcel = () => {
    const dataParaExcel = documentosFiltrados.map((doc) => ({
      DNI: doc.dni,
      "Nombre Completo": doc.nombreCompleto,
      "Tipo Documento": doc.tipo,
      "Fecha Documento": doc.fechaDoc
        ? format(doc.fechaDoc, "dd/MM/yyyy HH:mm", { locale: es })
        : "",
      "Fecha Firma": doc.fechaFirma
        ? format(doc.fechaFirma, "dd/MM/yyyy HH:mm", { locale: es })
        : "",
      "Fecha Vista": doc.fechaVista
        ? format(doc.fechaVista, "dd/MM/yyyy HH:mm", { locale: es })
        : "",
      Estado: doc.estado,
      Año: doc.ano,
      Mes: doc.mes,
    }));

    const ws = XLSX.utils.json_to_sheet(dataParaExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Documentos Onboarding");

    const fechaExport = format(new Date(), "yyyyMMdd_HHmm");
    XLSX.writeFile(wb, `documentos_onboarding_${fechaExport}.xlsx`);
  };

  // Ver documento
  const verDocumento = (documento) => {
    setDocumentoSeleccionado(documento);
    setShowModal(true);
  };

  // Obtener icono según el estado
  const getEstadoIcon = (estado) => {
    switch (estado) {
      case "firmado":
        return <FaCheckCircle className="text-success" size={16} />;
      case "visto":
        return <FaInfoCircle className="text-info" size={16} />;
      case "pendiente":
        return <FaExclamationCircle className="text-warning" size={16} />;
      default:
        return <FaRegFileAlt className="text-secondary" size={16} />;
    }
  };

  // Obtener color del badge según el estado
  const getEstadoBadge = (estado) => {
    const estadoObj = estadosDocumento.find((e) => e.value === estado);
    return estadoObj ? estadoObj.color : "secondary";
  };

  // Paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = documentosFiltrados.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(documentosFiltrados.length / itemsPerPage);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("desc");
    }
  };

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderBottom: "3px solid #f39c12",
            }}
          >
            <div style={{position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}} className="w-100">

              <div className="text-center">
                <h2 className="fw-bold mb-1">
                  <FaChartBar className="me-3" />
                  Estadísticas Onboarding
                </h2>
                <p className="mb-0 opacity-75">
                  Sistema de control y seguimiento de onboarding
                </p>
                {/* NUEVO: Indicador de cache cargado */}
                {cacheLoaded && (
                  <small className="d-block mt-1 opacity-75">
                    📋 {usuariosCache.size} empleados en cache
                  </small>
                )}
              </div>
              <div style={{position:"absolute",right:"20px"}}>
                <BotonManualHeader usuario={usuario} />
              </div>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Formulario de filtros */}
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body className="p-4">
                <Row className="align-items-end">
                  <Col md={4} lg={4}>
                    <Form.Group className="mb-3 mb-md-0">
                      <Form.Label className="fw-semibold text-dark">
                        <FaFileAlt className="me-2" />
                        Tipo de Documento
                      </Form.Label>
                      <Form.Select
                        value={filtros.tipoDocumento}
                        onChange={(e) =>
                          handleFiltroChange("tipoDocumento", e.target.value)
                        }
                        className="form-control-lg"
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                      >
                        {tiposDocumento.map((tipo) => (
                          <option key={tipo.value} value={tipo.value}>
                            {tipo.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={3} lg={3}>
                    <Form.Group className="mb-3 mb-md-0">
                      <Form.Label className="fw-semibold text-dark">
                        <FaCalendarAlt className="me-2" />
                        Período
                      </Form.Label>
                      <Form.Control
                        type="month"
                        value={filtros.periodo}
                        onChange={(e) =>
                          handleFiltroChange("periodo", e.target.value)
                        }
                        className="form-control-lg"
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={5} lg={5}>
                    <div className="d-grid d-md-flex gap-2">
                      <Button
                        variant="primary"
                        size="lg"
                        onClick={fetchDocumentos}
                        disabled={loading}
                        className="flex-fill"
                        style={{
                          borderRadius: "10px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                        }}
                      >
                        {loading ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            {!cacheLoaded
                              ? "Cargando usuarios..."
                              : "Consultando..."}
                          </>
                        ) : (
                          <>
                            <FaChartBar className="me-2" />
                            Generar Lista
                          </>
                        )}
                      </Button>

                      <Button
                        variant="outline-secondary"
                        size="lg"
                        onClick={limpiarFiltros}
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                        title="Limpiar filtros"
                      >
                        <FaTimes />
                      </Button>

                      <Button
                        variant="success"
                        size="lg"
                        onClick={exportarExcel}
                        disabled={documentosFiltrados.length === 0}
                        style={{ borderRadius: "10px" }}
                        title="Exportar a Excel"
                      >
                        <FaDownload />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* NUEVO: Alert de cache cargando */}
            {!cacheLoaded && rucEmpresa && (
              <Alert
                variant="info"
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "10px" }}
              >
                <div className="d-flex align-items-center">
                  <Spinner animation="border" size="sm" className="me-3" />
                  <div>
                    <h6 className="fw-bold mb-1">Preparando sistema</h6>
                    <p className="mb-0">Cargando información de empleados...</p>
                  </div>
                </div>
              </Alert>
            )}

            {/* Error Alert */}
            {error && (
              <Alert
                variant="warning"
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "10px" }}
              >
                <div className="d-flex align-items-center">
                  <FaExclamationTriangle className="me-3 fs-4" />
                  <div>
                    <h6 className="fw-bold mb-1">Error en la consulta</h6>
                    <p className="mb-0">{error}</p>
                  </div>
                </div>
              </Alert>
            )}

            {/* Indicadores Principales */}
            {!loading && documentos.length > 0 && (
              <Row className="g-3 mb-4">
                {/* Total Documentos */}
                <Col lg={3} md={6}>
                  <Card
                    className="h-100 shadow-sm border-0"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Body
                      className="p-4 text-center"
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: "white",
                      }}
                    >
                      <div className="mb-3">
                        <FaRegFileAlt size={40} className="text-white-50" />
                      </div>
                      <h1 className="display-4 fw-bold mb-2">
                        {estadisticas.total}
                      </h1>
                      <p className="mb-0 fw-semibold">Total Documentos</p>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Documentos Firmados */}
                <Col lg={3} md={6}>
                  <Card
                    className="h-100 shadow-sm border-0"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Body
                      className="p-4 text-center"
                      style={{
                        background:
                          "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                        color: "white",
                      }}
                    >
                      <div className="mb-3">
                        <FaCheckCircle size={40} className="text-white-50" />
                      </div>
                      <h1 className="display-4 fw-bold mb-2">
                        {estadisticas.firmados}
                      </h1>
                      <p className="mb-0 fw-semibold">Documentos Firmados</p>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Documentos Pendientes */}
                <Col lg={3} md={6}>
                  <Card
                    className="h-100 shadow-sm border-0"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Body
                      className="p-4 text-center"
                      style={{
                        background:
                          "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                        color: "white",
                      }}
                    >
                      <div className="mb-3">
                        <FaExclamationCircle
                          size={40}
                          className="text-white-50"
                        />
                      </div>
                      <h1 className="display-4 fw-bold mb-2">
                        {estadisticas.pendientes}
                      </h1>
                      <p className="mb-0 fw-semibold">Documentos Pendientes</p>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Tasa de Cumplimiento */}
                <Col lg={3} md={6}>
                  <Card
                    className="h-100 shadow-sm border-0"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Body
                      className="p-4 text-center"
                      style={{
                        background:
                          "linear-gradient(135deg, #79b3e9ff 0%, #a3b5e4ff 100%)",
                        color: "white",
                      }}
                    >
                      <div className="mb-3">
                        <FaChartBar size={40} className="text-white-50" />
                      </div>
                      <h1 className="display-4 fw-bold mb-2">
                        {estadisticas.porcentajeFirmados}%
                      </h1>
                      <p className="mb-0 fw-semibold">Cumplimiento</p>
                      <Badge
                        bg={
                          estadisticas.porcentajeFirmados >= 80
                            ? "success"
                            : estadisticas.porcentajeFirmados >= 60
                            ? "warning"
                            : "danger"
                        }
                        className="mt-2"
                      >
                        {estadisticas.porcentajeFirmados >= 80
                          ? "Excelente"
                          : estadisticas.porcentajeFirmados >= 60
                          ? "Regular"
                          : "Bajo"}
                      </Badge>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}

            {/* Tabla de Documentos */}
            {!loading && documentosFiltrados.length > 0 && (
              <>
                <Card
                  className="shadow-sm border-0 mb-4"
                  style={{ borderRadius: "15px" }}
                >
                  <Card.Header className="bg-primary text-white py-3">
                    <div className="d-flex align-items-center">
                      <FaUsers className="me-2" />
                      <div className="flex-grow-1">
                        <h5 className="mb-0 fw-semibold">
                          Documentos Encontrados
                        </h5>
                        {filtros.tipoDocumento && (
                          <small className="opacity-75 d-block">
                            <FaFileAlt className="me-1" size={12} />
                            {
                              tiposDocumento.find(
                                (tipo) => tipo.value === filtros.tipoDocumento
                              )?.label
                            }
                          </small>
                        )}
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {filtros.tipoDocumento && (
                          <Badge bg="warning" className="text-dark">
                            <FaFilter className="me-1" size={10} />
                            Filtrado
                          </Badge>
                        )}
                        <Badge
                          bg="light"
                          text="primary"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {documentosFiltrados.length} docs
                        </Badge>
                      </div>
                    </div>
                  </Card.Header>

                  <Card.Body className="p-0">
                    <div style={{ maxHeight: "700px", overflowY: "auto" }}>
                      <Table
                        hover
                        className="mb-0"
                        style={{ fontSize: "0.9rem" }}
                      >
                        <thead
                          style={{
                            backgroundColor: "#f8f9fa",
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                          }}
                        >
                          <tr>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold"
                              style={{ width: "50px" }}
                            >
                              #
                            </th>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold"
                              style={{ cursor: "pointer", width: "110px" }}
                              onClick={() => handleSort("dni")}
                            >
                              DNI
                              {sortField === "dni" && (
                                <span className="ms-1">
                                  {sortDirection === "asc" ? (
                                    <FaSortAmountUp />
                                  ) : (
                                    <FaSortAmountDown />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold"
                              style={{ cursor: "pointer", minWidth: "250px" }}
                              onClick={() => handleSort("nombreCompleto")}
                            >
                              Empleado
                              {sortField === "nombreCompleto" && (
                                <span className="ms-1">
                                  {sortDirection === "asc" ? (
                                    <FaSortAmountUp />
                                  ) : (
                                    <FaSortAmountDown />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold"
                              style={{ cursor: "pointer", width: "140px" }}
                              onClick={() => handleSort("fechaDoc")}
                            >
                              Fecha Doc.
                              {sortField === "fechaDoc" && (
                                <span className="ms-1">
                                  {sortDirection === "asc" ? (
                                    <FaSortAmountUp />
                                  ) : (
                                    <FaSortAmountDown />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold"
                              style={{ cursor: "pointer", width: "140px" }}
                              onClick={() => handleSort("fechaFirma")}
                            >
                              Fecha Firma
                              {sortField === "fechaFirma" && (
                                <span className="ms-1">
                                  {sortDirection === "asc" ? (
                                    <FaSortAmountUp />
                                  ) : (
                                    <FaSortAmountDown />
                                  )}
                                </span>
                              )}
                            </th>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold"
                              style={{ width: "120px" }}
                            >
                              Estado
                            </th>
                            <th
                              className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                              style={{ width: "100px" }}
                            >
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((doc, index) => (
                            <tr
                              key={doc.id}
                              style={{ borderLeft: "3px solid transparent" }}
                            >
                              <td className="py-3 px-3 text-muted">
                                {indexOfFirstItem + index + 1}
                              </td>
                              <td className="py-3 px-3">
                                <span className="fw-semibold text-dark">
                                  {doc.dni}
                                </span>
                              </td>
                              <td className="py-3 px-3">
                                <div>
                                  <span className="text-dark fw-medium d-block">
                                    {doc.nombreCompleto}
                                  </span>
                                  {doc.nombreCompleto ===
                                    "Usuario no encontrado" && (
                                    <small className="text-danger">
                                      ⚠️ Usuario no registrado
                                    </small>
                                  )}
                                  {doc.nombreCompleto ===
                                    "Error al cargar nombre" && (
                                    <small className="text-warning">
                                      ⚠️ Error de consulta
                                    </small>
                                  )}
                                </div>
                              </td>
                              <td className="py-3 px-3">
                                {doc.fechaDoc && (
                                  <div>
                                    <div className="fw-medium text-dark">
                                      {format(doc.fechaDoc, "dd/MM/yyyy", {
                                        locale: es,
                                      })}
                                    </div>
                                    <small className="text-muted">
                                      {format(doc.fechaDoc, "HH:mm", {
                                        locale: es,
                                      })}
                                    </small>
                                  </div>
                                )}
                              </td>
                              <td className="py-3 px-3">
                                {doc.fechaFirma ? (
                                  <div>
                                    <div className="fw-medium text-success">
                                      {format(doc.fechaFirma, "dd/MM/yyyy", {
                                        locale: es,
                                      })}
                                    </div>
                                    <small className="text-muted">
                                      {format(doc.fechaFirma, "HH:mm", {
                                        locale: es,
                                      })}
                                    </small>
                                  </div>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td className="py-3 px-3">
                                <div className="d-flex align-items-center">
                                  {getEstadoIcon(doc.estado)}
                                  <Badge
                                    bg={getEstadoBadge(doc.estado)}
                                    className="ms-2 fw-normal"
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    {doc.estado}
                                  </Badge>
                                </div>
                              </td>
                              <td className="py-3 px-3 text-center">
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="outline-secondary"
                                    size="sm"
                                    className="border-0"
                                    style={{ borderRadius: "8px" }}
                                  >
                                    <FaCog />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() => verDocumento(doc)}
                                    >
                                      <FaEye className="me-2" />
                                      Ver detalles
                                    </Dropdown.Item>
                                    {(doc.link || doc.linkFirmado) && (
                                      <Dropdown.Item
                                        as="a"
                                        href={doc.linkFirmado || doc.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <FaDownload className="me-2" />
                                        Descargar
                                      </Dropdown.Item>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>

                {/* Paginación */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="text-muted">
                      Mostrando {indexOfFirstItem + 1}-
                      {Math.min(indexOfLastItem, documentosFiltrados.length)} de{" "}
                      {documentosFiltrados.length} registros
                    </div>
                    <Pagination className="mb-0">
                      <Pagination.First
                        onClick={() => setCurrentPage(1)}
                        disabled={currentPage === 1}
                      />
                      <Pagination.Prev
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      />

                      {Array.from(
                        { length: Math.min(5, totalPages) },
                        (_, i) => {
                          let pageNumber;
                          if (totalPages <= 5) {
                            pageNumber = i + 1;
                          } else if (currentPage <= 3) {
                            pageNumber = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNumber = totalPages - 4 + i;
                          } else {
                            pageNumber = currentPage - 2 + i;
                          }

                          return (
                            <Pagination.Item
                              key={pageNumber}
                              active={pageNumber === currentPage}
                              onClick={() => setCurrentPage(pageNumber)}
                            >
                              {pageNumber}
                            </Pagination.Item>
                          );
                        }
                      )}

                      <Pagination.Next
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        disabled={currentPage === totalPages}
                      />
                      <Pagination.Last
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                )}
              </>
            )}

            {/* Estados Vacíos */}
            {!loading && documentos.length === 0 && (
              <Card
                className="shadow-sm border-0"
                style={{ borderRadius: "15px" }}
              >
                <Card.Body className="py-5">
                  <div className="text-center">
                    <div
                      className="bg-light rounded-circle mx-auto mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaFileSignature size={32} className="text-muted" />
                    </div>
                    <h5 className="text-muted mb-2">
                      No se encontraron documentos
                    </h5>
                    <p className="text-muted mb-4">
                      Utiliza los filtros de búsqueda para encontrar documentos
                      de onboarding.
                    </p>
                    <Button
                      variant="primary"
                      onClick={fetchDocumentos}
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        border: "none",
                        borderRadius: "10px",
                      }}
                    >
                      <FaSearch className="me-2" />
                      Realizar búsqueda
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            )}

            {!loading &&
              documentos.length > 0 &&
              documentosFiltrados.length === 0 && (
                <Card
                  className="shadow-sm border-0"
                  style={{ borderRadius: "15px" }}
                >
                  <Card.Body className="py-5">
                    <div className="text-center">
                      <div
                        className="bg-light rounded-circle mx-auto mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaFilter size={32} className="text-muted" />
                      </div>
                      <h5 className="text-muted mb-2">Sin resultados</h5>
                      <p className="text-muted mb-4">
                        No se encontraron documentos que coincidan con los
                        filtros aplicados.
                      </p>
                      <Button
                        variant="outline-primary"
                        onClick={limpiarFiltros}
                        style={{ borderRadius: "10px" }}
                      >
                        <FaTimes className="me-2" />
                        Limpiar filtros
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              )}
          </Card.Body>
        </Card>

        {/* Modal Mejorado */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton className="border-0 pb-2">
            <Modal.Title className="d-flex align-items-center">
              <div
                className="rounded-3 p-2 me-3"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                }}
              >
                <FaFileAlt />
              </div>
              Detalles del Documento
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {documentoSeleccionado && (
              <>
                <Row className="g-4">
                  <Col md={6}>
                    <Card
                      className="border-0 bg-light h-100"
                      style={{ borderRadius: "10px" }}
                    >
                      <Card.Body>
                        <h6 className="fw-bold text-primary mb-3">
                          <FaInfoCircle className="me-2" />
                          Información General
                        </h6>
                        <div className="mb-3">
                          <strong className="text-secondary d-block mb-1">
                            DNI:
                          </strong>
                          <span className="fw-semibold">
                            {documentoSeleccionado.dni}
                          </span>
                        </div>
                        <div className="mb-3">
                          <strong className="text-secondary d-block mb-1">
                            Tipo:
                          </strong>
                          <span>{documentoSeleccionado.tipo}</span>
                        </div>
                        <div className="mb-3">
                          <strong className="text-secondary d-block mb-1">
                            Empleado:
                          </strong>
                          <span>{documentoSeleccionado.nombreCompleto}</span>
                        </div>
                        <div>
                          <strong className="text-secondary d-block mb-1">
                            Estado:
                          </strong>
                          <Badge
                            bg={getEstadoBadge(documentoSeleccionado.estado)}
                            className="mt-1"
                          >
                            {documentoSeleccionado.estado}
                          </Badge>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card
                      className="border-0 bg-light h-100"
                      style={{ borderRadius: "10px" }}
                    >
                      <Card.Body>
                        <h6 className="fw-bold text-primary mb-3">
                          <FaCalendarAlt className="me-2" />
                          Fechas y Control
                        </h6>
                        <div className="mb-3">
                          <strong className="text-secondary d-block mb-1">
                            Fecha Documento:
                          </strong>
                          <span>
                            {documentoSeleccionado.fechaDoc &&
                              format(
                                documentoSeleccionado.fechaDoc,
                                "dd/MM/yyyy HH:mm",
                                { locale: es }
                              )}
                          </span>
                        </div>
                        <div className="mb-3">
                          <strong className="text-secondary d-block mb-1">
                            Fecha Firma:
                          </strong>
                          <span>
                            {documentoSeleccionado.fechaFirma ? (
                              format(
                                documentoSeleccionado.fechaFirma,
                                "dd/MM/yyyy HH:mm",
                                { locale: es }
                              )
                            ) : (
                              <span className="text-muted">No firmado</span>
                            )}
                          </span>
                        </div>
                        <div className="mb-3">
                          <strong className="text-secondary d-block mb-1">
                            Fecha Vista:
                          </strong>
                          <span>
                            {documentoSeleccionado.fechaVista ? (
                              format(
                                documentoSeleccionado.fechaVista,
                                "dd/MM/yyyy HH:mm",
                                { locale: es }
                              )
                            ) : (
                              <span className="text-muted">No visto</span>
                            )}
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            {documentoSeleccionado?.linkFirmado && (
              <Button
                variant="success"
                as="a"
                href={documentoSeleccionado.linkFirmado}
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
                style={{ borderRadius: "8px" }}
              >
                <FaDownload className="me-2" />
                Descargar Firmado
              </Button>
            )}
            {documentoSeleccionado?.link && (
              <Button
                variant="primary"
                as="a"
                href={documentoSeleccionado.link}
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
                style={{
                  borderRadius: "8px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                <FaEye className="me-2" />
                Ver Original
              </Button>
            )}
            <Button
              variant="outline-secondary"
              onClick={() => setShowModal(false)}
              style={{ borderRadius: "8px" }}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}

export default ListaDocumentosDetalle;


